import ModalCustom from '../../UI/modal';
import AddItineraryForm from '../../forms/add-itinerary-form';

type Props = {
  show: boolean;
  handleClose: () => void;
};

const AddItineraryModal = ({ show, handleClose }: Props) => {
  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title='Add Itinerary'
      paddingBody='30px 32px 32px'
    >
      <AddItineraryForm
        label='Itinerary Name'
        placeholder='Enter itinerary name'
        submitTitle='Add Itinerary'
        onSuccess={handleClose}
      />
    </ModalCustom>
  );
};

export default AddItineraryModal;
